<template>
    <BApp>
        <div>
            <div class="container d-flex justify-content-center">
                <div class="max-content-width w-100">
                    <Navbar></Navbar>
                </div>
            </div>

            <div class="container d-flex justify-content-center pt-md-5 pt-sm-3">
                <steps :active-step="store.step" :steps="store.steps"></steps>
            </div>

            <div class="container d-flex justify-content-center">
                <keep-alive>
                    <component v-bind:is="store.step"></component>
                </keep-alive>
            </div>
            <div class="container d-flex justify-content-center">
                <PriceList></PriceList>
            </div>
        </div>
    </BApp>
</template>

<script setup>
import {BApp} from 'bootstrap-vue-next'
import { onMounted, watch } from 'vue';
import Steps from './components/Steps.vue';
import { useMainStore } from './includes/store';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import { localize } from '@vee-validate/i18n';
import PriceList from './components/PriceList.vue';
import Navbar from './components/Navbar.vue';

const { locale } = useI18n();

const store = useMainStore();

const hashChange = () => {
    let currentStep = window.location.hash.substr(1);
    
    store.changeStep(currentStep);
    console.log("Changing step to " + currentStep);
}

window.onhashchange = _ => {
    hashChange();
};
hashChange();

const loadState = () => {
    axios.get('/intro').then(response => {
        let locale = new URL(location.href).searchParams.get('lang');
        if (locale) {
            store.setLocale(locale);
        } else {
            store.setLocale(response.data.default_language);
        }

        store.setWebsite(response.data);

        if (!store.stateLoaded || !store.stepInfo.adType) {
            store.setAdType(response.data.default_ad_type);
        }
    });

    axios.get('/state').then((response) => {
        const store = useMainStore();

        let data = response.data;
        if (data.adType) {
            store.setAdType(data.adType);
        }
        if (data.newspapers) {
            store.setNewspapers(data.newspapers);
        }
        if (data.client) {
            store.setClient(data.client);
        }
        if (data.greeting) {
            store.setGreeting(data.greeting);
        }
        if (data.advertisement) {
            store.setAdvertisement(data.advertisement);
        }
        if (data.condolence) {
            store.setCondolence(data.condolence);
        }
        if (data.dates) {
            store.setDates(data.dates);
        }
        store.setStateLoaded();

        axios.get('/api/newspapers').then(result => {
            let newsPapersCopy = [];
            if (!Array.isArray(store.stepInfo.newspapers) || store.stepInfo.newspapers.length === 0) {
                console.log("Received newspapers settings");
                result.data.forEach(p => {
                    newsPapersCopy.push(p);
                });
            } else {
                store.stepInfo.newspapers.forEach((newsPaper) => {
                    result.data.forEach(p => {
                        if (p.slug === newsPaper.slug) {
                            newsPaper.publish_dates = p.publish_dates;
                            newsPaper.ad_types = p.ad_types;
                            newsPaper.business_prices = p.business_prices;
                            newsPaper.lang = p.lang;
                            newsPaper.lock_hours = p.lock_hours;
                            newsPaper.private_prices = p.private_prices;
                            newsPapersCopy.push(newsPaper);
                        }
                    });
                });
            }

            store.setNewspapers(newsPapersCopy);
        });
    });
}

onMounted(() => {
    loadState();
});

watch(() => store.locale, (newLocale) => {
    locale.value = newLocale;
    localize(newLocale);
}, { immediate: true });

</script>